/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CollaboratorAssessmentResponseCto } from '../../models/collaborator-assessment-response-cto';

export interface GetByJobIdAsync$Plain$Params {
  companyGuid: string;
  jobId: string;
}

export function getByJobIdAsync$Plain(http: HttpClient, rootUrl: string, params: GetByJobIdAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CollaboratorAssessmentResponseCto>>> {
  const rb = new RequestBuilder(rootUrl, getByJobIdAsync$Plain.PATH, 'get');
  if (params) {
    rb.path('companyGuid', params.companyGuid, {});
    rb.path('jobId', params.jobId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CollaboratorAssessmentResponseCto>>;
    })
  );
}

getByJobIdAsync$Plain.PATH = '/collaborator-assessment/company/{companyGuid}/job/{jobId}';
